export type NavItem = {
  label: string;
  path: string;
  description: string;
};

export const navItems: NavItem[] = [
  {
    label: 'Le cabinet',
    path: '/cabinet',
    description: "Notre histoire, notre équipe et les valeurs qui guident nos interventions auprès des territoires.",
  },
  {
    label: 'Expertises',
    path: '/expertises',
    description: "Le détail de nos domaines d'intervention, de la stratégie habitat au pilotage des projets de renouvellement urbain.",
  },
  {
    label: 'Références',
    path: '/references',
    description: "Une sélection de missions menées pour des collectivités, bailleurs sociaux et opérateurs publics.",
  },
  {
    label: 'Actualités',
    path: '/actualites',
    description: "Nos analyses, publications et l'actualité des politiques de l'habitat et de la ville.",
  },
  {
    label: 'Contact',
    path: '/contact',
    description: "Nos coordonnées et un formulaire pour nous présenter votre projet ou votre consultation.",
  },
];
